/**
 * Supabase Client Configuration
 * 
 * Initializes and exports the Supabase client for authentication and database access.
 */

import { createClient } from '@supabase/supabase-js';
import { FEATURES } from '../config/features';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (FEATURES.AUTHENTICATION && (!supabaseUrl || !supabaseAnonKey)) {
  throw new Error(
    'Missing Supabase environment variables. Please check .env.local file.'
  );
}

/**
 * Supabase client instance
 * Used for authentication, database queries, and real-time subscriptions
 */
export const supabase = FEATURES.AUTHENTICATION && supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null as any;

export default supabase;
